// ==== frontend/src/pages/BuyBook.js

import Header from '../Header';
import Footer from '../Footer';
import BookFormatCard from '../components/BookFormatCard';
import { usePurchaseForm } from '../hooks/usePurchaseForm';
import '../css/buyBook.css';

const PRICING = {
  paperback: 19.79,
  ebookNormal: 9.99,
  ebook: 9.99,
  audiobookNormal: 19.99,
  audiobook: 19.99,
};

function BuyBook() {
  const paperbackForm = usePurchaseForm({ type: 'PAPERBACK', price: PRICING.paperback, needsShipping: true });
  const ebookForm = usePurchaseForm({ type: 'EBOOK', price: PRICING.ebook });
  const audiobookForm = usePurchaseForm({ type: 'AUDIOBOOK', price: PRICING.audiobook });

  return (
    <div className="buy-book-page">
      <Header />

      <div className="buy-book-hero">
        <div className="eyebrow">Persist, Persist, Persist.</div>
        <h1>Choose Your Preferred Format  </h1>
        
      </div>

      <div  className="buy-book-grid">
        <BookFormatCard
          form={paperbackForm}
          image="/images/new_images/3.png"
          format="Physical Book"
          title="Paperback Edition"
          price={PRICING.paperback}
          features={[
            'Premium paperback print',
            'Signed by the author on request',
            'Ships within 3–5 business days',
            'The full, unabridged story',
          ]}
          ctaLabel="Buy Paperback"
          needsShipping
          moreInfo={{ href: '/Endorsements', label: 'Read what early readers are saying' }}
        />

        <BookFormatCard
          form={ebookForm}
          image="/images/new_images/11.png"
          format="eBook"
          title="Digital Edition"
          price={PRICING.ebook}
          originalPrice={PRICING.ebookNormal}
          features={[
            'Instant access after checkout',
            'Read on any device',
            'Full table of contents & chapter navigation',
            'Save 10% off the list price',
          ]}
          ctaLabel="Buy eBook"
          moreInfo={{ href: '/Preview', label: 'Read a free preview' }}
        />

        <BookFormatCard
          form={audiobookForm}
           image="/images/new_images/10.png"
          format="Audiobook"
          title="Audiobook Edition"
          price={PRICING.audiobook}
          originalPrice={PRICING.audiobookNormal}
          features={[
            'Narrated by the author himself',
            'Stream instantly after checkout',
            'Chapter-by-chapter navigation',
            'Save 15% off the list price',
          ]}
          ctaLabel="Buy Audiobook"
          moreInfo={{ href: '/Endorsements', label: 'Read what early readers are saying' }}
        />
      </div>

      <div className="buy-book-trust">
        <span><i className="bi bi-shield-lock-fill" /> Secure checkout</span>
        <span><i className="bi bi-envelope-check-fill" /> Instant order confirmation by email</span>
        <span><i className="bi bi-headset" /> Questions? hello@juniorpersist.com</span>
      </div>

      <br /><br />
      <Footer />
    </div>
  );
}

export default BuyBook;
